const mockTestData = [
  {
    id: 1,
    title: 'Mock Test 1',
    title_vi: 'Bài Kiểm Tra Mô Phỏng 1',
    description: 'Test your knowledge on basic driving rules and road signs',
    description_vi: 'Kiểm tra kiến thức của bạn về các quy tắc lái xe cơ bản và biển báo đường bộ',
    questions: [
      {
        id: 1,
        text: 'Unless otherwise posted, what is the basic speed limit outside a city, town or village on a primary highway?',
        text_vi: 'Trừ khi có quy định khác, giới hạn tốc độ cơ bản ngoài thành phố, thị trấn hoặc làng trên đường cao tốc chính là bao nhiêu?',
        options: ['100 km/h', '80 km/h', '60 km/h', '50 km/h'],
        options_vi: ['100 km/h', '80 km/h', '60 km/h', '50 km/h'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 2,
        text: 'When backing a passenger vehicle to the left, a driver should:',
        text_vi: 'Khi lùi một chiếc xe chở khách sang trái, tài xế nên:',
        options: ['Look in the inside rear-view mirror and make steering adjustments as necessary', 'Look over the right shoulder with occasional glances to the front', 'Look over the left shoulder with occasional glances to the front', 'Without shoulder checking, use the inside and outside rear-view mirrors to ensure the best view to the rear and both sides of the vehicle'],
        options_vi: ['Nhìn vào gương chiếu hậu bên trong và điều chỉnh vô lăng khi cần thiết', 'Nhìn qua vai phải với những cái nhìn thoáng qua về phía trước', 'Nhìn qua vai trái với những cái nhìn thoáng qua về phía trước', 'Không kiểm tra vai, sử dụng gương chiếu hậu bên trong và bên ngoài để đảm bảo tầm nhìn tốt nhất về phía sau và cả hai bên của xe'],
        img: null,  
        answerIndex: 2,
      },
      {
        id: 3,
        text: 'When approaching an intersection and facing a traffic control light that is showing a green right-turn arrow and a red light, a driver',
        text_vi: 'Khi tiếp cận một ngã tư và đối mặt với đèn điều khiển giao thông hiển thị mũi tên rẽ phải xanh và đèn đỏ, tài xế',
        options: ['Must stop and wait for a green light before turning in the direction of the arrow', 'May go straight through the intersection without stopping', 'May proceed when safe, without stopping, in the direction of the arrow', 'May turn left without stopping'],
        options_vi: ['Phải dừng lại và chờ đèn xanh trước khi rẽ theo hướng của mũi tên', 'Có thể đi thẳng qua ngã tư mà không dừng lại', 'Có thể tiếp tục khi an toàn, không dừng lại, theo hướng của mũi tên', 'Có thể rẽ trái mà không dừng lại'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 4,
        text: 'Alberta has a demerit point system where a fully licenced (non-learner, non-probationary) driver is suspended when they accumulate',
        text_vi: 'Alberta có hệ thống điểm trừ trong đó tài xế được cấp phép đầy đủ (không phải người học, không phải thử nghiệm) bị đình chỉ khi tích lũy',
        options: ['15 points', '8 points', '5 points', '12 points'],
        options_vi: ['15 điểm', '8 điểm', '5 điểm', '12 điểm'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 5,
        text: 'When passing a large truck on a two-way highway, a driver should',
        text_vi: 'Khi vượt một chiếc xe tải lớn trên đường cao tốc hai chiều, tài xế nên',
        options: ['Leave extra room before returning to their lane', 'Return to their lane when signalled by the truck\'s headlights', 'Return to their lane when the truck is no longer visible in any of their rear-view mirrors', 'Return to their lane once they have cleared the truck\'s front bumper'],
        options_vi: ['Để lại khoảng trống thêm trước khi quay lại làn đường của họ', 'Quay lại làn đường của họ khi được báo hiệu bởi đèn pha của xe tải', 'Quay lại làn đường khi xe tải không còn nhìn thấy trong bất kỳ gương chiếu hậu nào', 'Quay lại làn đường sau khi vượt qua cản nước trước của xe tải'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 6,
        text: 'Which statement best describes the steps for turning right at a red traffic light?',
        text_vi: 'Câu nào mô tả đầy đủ nhất các bước rẽ phải tại đèn giao thông đỏ?',
        options: ['Right turns on a red traffic light are never permitted', 'Signal and make sure there is no sign prohibiting the turn, stop, look left and right, yield the right-of-way, then proceed', 'Reduce speed before the turn, look right for cyclists, signal and proceed', 'Signal and reduce speed before the turn, look left, yield to vehicles and proceed'],
        options_vi: ['Rẽ phải tại đèn giao thông đỏ không bao giờ được phép', 'Báo hiệu và đảm bảo không có biển báo cấm rẽ, dừng lại, nhìn sang trái và phải, nhường quyền đi, sau đó tiếp tục', 'Giảm tốc độ trước khi rẽ, nhìn sang phải để tìm người đi xe đạp, báo hiệu và tiếp tục', 'Báo hiệu và giảm tốc độ trước khi rẽ, nhìn sang trái, nhường quyền cho các phương tiện khác và tiếp tục'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 7,
        text: 'This sign indicates:',
        text_vi: 'Biển báo này biểu thị:',
        options: ['Route for vehicles over 4500 kg', 'Route for slow moving vehicles', 'Reserved lane for buses', 'Dangerous goods route'],
        options_vi: ['Tuyến đường cho xe trên 4500 kg', 'Tuyến đường cho xe chuyển động chậm', 'Làn dành riêng cho xe buýt', 'Tuyến đường hàng hóa nguy hiểm'],
        img: '/assets/7.png',
        answerIndex: 3,
      },
      {
        id: 8,
        text: 'A single solid white line between driving lanes in an urban area means',
        text_vi: 'Một đường trắng liền lạc giữa các làn đường trong khu đô thị có nghĩa là',
        options: ['It is a line separating traffic travelling in opposite directions', 'Traffic on the right is moving faster than traffic on the left', 'Lane changing is not permitted', 'Lane change is permitted'],
        options_vi: ['Đó là một đường phân tách giao thông đi theo các hướng đối lập', 'Giao thông bên phải chuyển động nhanh hơn giao thông bên trái', 'Không được phép thay đổi làn đường', 'Thay đổi làn đường được phép'],
        img: null ,
        answerIndex: 2
      },
      {
        id: 9,
        text: 'A "parking lane" as defined in the Basic Licence Driver\'s Handbook is:',
        text_vi: 'Một "làn đỗ xe" như được định nghĩa trong Sổ tay Người Lái Xe Cấp Phép Cơ Bản là:',
        options: ['A lane closest to the curb, where parking is permitted but there are no meters', 'All of these responses are correct', 'That portion of a primary highway between the edge of the roadway to the right of the direction of traffic and the nearest solid white line, not being the centre line, marked on the roadway', 'A lane immediately beside a row of parking meters in an urban area'],
        options_vi: ['Một làn gần lề nhất, nơi được phép đỗ xe nhưng không có đồng hồ', 'Tất cả các câu trả lời này đều đúng', 'Phần đó của một đường cao tốc chính giữa cạnh đường bên phải của hướng giao thông và đường trắng liền lạc gần nhất, không phải đường trung tâm, được đánh dấu trên đường', 'Một làn ngay cạnh một hàng đồng hồ đỗ xe trong khu đô thị'],
        img: null ,
        answerIndex: 2
      },
      {
        id: 10,
        text: 'Shoulder checking means:',
        text_vi: 'Kiểm tra vai có nghĩa là:',
        options: ['Glancing towards the blind spot in the direction the driver intends to move', 'Glancing into the left outside mirror', 'Glancing into both the inside and outside mirrors', 'Glancing into the right outside mirror'],
        options_vi: ['Nhìn nhanh vào điểm mù theo hướng tài xế dự định di chuyển', 'Nhìn vào gương bên ngoài bên trái', 'Nhìn vào cả gương bên trong và bên ngoài', 'Nhìn vào gương bên ngoài bên phải'],
        img: null ,
        answerIndex: 0
      },
      {
        id: 11,
        text: 'This sign indicates:',
        text_vi: 'Biển báo này biểu thị:',
        options: ['Off-road facilities ahead', 'Slippery when wet', 'Uneven pavement', 'Detour ahead'],
        options_vi: ['Các tiện nghi ngoài đường phía trước', 'Trơn khi ướt', 'Nền đường không bằng', 'Đã quay vòng phía trước'],
        img: '/assets/11.png',
        answerIndex: 2
      },
      {
        id: 12,
        text: 'A traffic-lane control light with an illuminated red "X" means:',
        text_vi: 'Đèn điều khiển làn giao thông với "X" đỏ sáng có nghĩa là:',
        options: ['Prepare for an emergency vehicle travelling in that lane', 'Reduce speed to below 30 km/h', 'Use that lane only for the purpose of making left turns', 'Travel is not permitted in that lane'],
        options_vi: ['Chuẩn bị cho chiếc xe khẩn cấp đi qua làn đó', 'Giảm tốc độ xuống dưới 30 km/h', 'Sử dụng làn đó chỉ để rẽ trái', 'Không được phép đi qua làn đó'],
        img: '/assets/12.png',
        answerIndex: 3
      },
      {
        id: 13,
        text: 'Does a parent have the right to withdraw a previously given "parental consent" for someone under 18 years of age with respect to an operator\'s licence?',
        text_vi: 'Cha mẹ có quyền rút lại "sự đồng ý của cha mẹ" được cấp trước đó cho người dưới 18 tuổi liên quan đến giấy phép lái xe không?',
        options: ['Yes, provided the person is still under the age of 18 and is not self-supporting or married', 'Yes, provided that both parents verbally agree to withdraw the consent at a registry office', 'No, once it is given it remains in effect until the person reaches 18 years of age', 'No, but another consent form must be signed by both parents after a licence suspension'],
        options_vi: ['Có, miễn là người đó vẫn dưới 18 tuổi và không tự nuôi sống hoặc có gia đình', 'Có, miễn là cả hai cha mẹ đồng ý miệng rút lại sự đồng ý tại văn phòng đăng ký', 'Không, sau khi được cấp, nó có hiệu lực cho đến khi người đó đủ 18 tuổi', 'Không, nhưng một mẫu đồng ý khác phải được ký bởi cả hai cha mẹ sau khi giấy phép bị đình chỉ'],
        img: null,
        answerIndex: 0
      },
      {
        id: 14,
        text: 'When approaching a Yield sign, you must:',
        text_vi: 'Khi tiếp cận biển báo Nhường, bạn phải:',
        options: ['Yield the right-of-way to traffic not facing the sign and all pedestrians in the intersection', 'Always sound the horn to warn other traffic within the intersection', 'Expect all other vehicles to yield the right-of-way to you', 'Come to a stop and proceed after looking to the right and left'],
        options_vi: ['Nhường quyền đi cho giao thông không đối mặt với biển báo và tất cả người đi bộ trong ngã tư', 'Luôn luôn kêu còi để cảnh báo giao thông khác trong ngã tư', 'Mong đợi tất cả các phương tiện khác nhường quyền cho bạn', 'Dừng lại và tiếp tục sau khi nhìn sang phải và trái'],
        img: null,
        answerIndex: 0
      },
      {
        id: 15,
        text: 'The term "over-driving" your headlights at night means:',
        text_vi: 'Thuật ngữ "lái xe vượt quá" đèn pha của bạn vào ban đêm có nghĩa là:',
        options: ['The driver cannot see clearly for 1000 metres', 'The low beam headlights are not set properly', 'The driver is travelling at a speed which would not permit them to see an object in time to stop', 'The driver has had the headlights on for too long a time'],
        options_vi: ['Tài xế không thể nhìn rõ ràng trong 1000 mét', 'Đèn pha chùm thấp không được đặt đúng cách', 'Tài xế đang lái xe với tốc độ mà sẽ không cho phép họ nhìn thấy một vật thể kịp thời để dừng lại', 'Tài xế đã bật đèn pha quá lâu'],
        img: null,
        answerIndex: 2
      },
      {
        id: 16,
        text: 'Under the Graduated Driver Licensing program, a driver will receive 2 demerits:',
        text_vi: 'Theo chương trình Cấp phép Lái xe Theo bậc, tài xế sẽ nhận 2 điểm trừ:',
        options: ['For having more passengers than there are seat belts', 'For not wearing a seat belt securely fastened', 'For not wearing a seat belt', 'For not wearing a seat belt properly adjusted'],
        options_vi: ['Vì có nhiều hành khách hơn dây an toàn', 'Vì không buộc dây an toàn chắc chắn', 'Vì không mặc dây an toàn', 'Vì không điều chỉnh dây an toàn đúng cách'],
        img: null,
        answerIndex: 0
      },
      {
        id: 17,
        text: 'Using the 2-second rule to judge a safe following distance when driving:',
        text_vi: 'Sử dụng quy tắc 2 giây để đánh giá khoảng cách an toàn khi lái xe:',
        options: ['Is more accurate on rural highways than in urban centres', 'Is not accurate at speeds greater than 100 km/h', 'Is accurate at any speed', 'Is not accurate at speeds lower than 30 km/h'],
        options_vi: ['Chính xác hơn trên đường cao tốc nông thôn so với các trung tâm đô thị', 'Không chính xác ở tốc độ lớn hơn 100 km/h', 'Chính xác ở bất kỳ tốc độ nào', 'Không chính xác ở tốc độ dưới 30 km/h'],
        img: null,
        answerIndex: 2
      },
      {
        id: 18,
        text: 'This sign indicates:',
        text_vi: 'Biển báo này biểu thị:',
        options: ['Traffic entering from the right', 'Winding road ahead', 'Curve right', 'Concealed intersection on the right'],
        options_vi: ['Giao thông vào từ bên phải', 'Đường quanh co phía trước', 'Quanh cơ bên phải', 'Ngã tư kín trên bên phải'],
        img: '/assets/18.png',
        answerIndex: 2
      },
      {
        id: 19,
        text: 'A driver approaching a flashing red traffic light must:',
        text_vi: 'Tài xế tiếp cận đèn giao thông đỏ nhấp nháy phải:',
        options: ['Stop and wait for the flashing green light', 'Reduce speed and proceed with caution', 'Stop and proceed only when safe to do so', 'Stop until the signal light turns green'],
        options_vi: ['Dừng lại và chờ đèn xanh nhấp nháy', 'Giảm tốc độ và tiếp tục với cẩn thận', 'Dừng lại và chỉ tiếp tục khi an toàn', 'Dừng lại cho đến khi đèn tín hiệu chuyển sang xanh'],
        img: null ,
        answerIndex: 2
      },
      {
        id: 20,
        text: 'This sign indicates:',
        text_vi: 'Biển báo này biểu thị:',
        options: ['Do not enter', 'Slow moving vehicles ahead', 'Warning, Yield sign ahead', 'Warning, traffic is approaching'],
        options_vi: ['Không vào', 'Xe chuyển động chậm phía trước', 'Cảnh báo, biển báo Nhường phía trước', 'Cảnh báo, giao thông đang tiến tới'],
        img: '/assets/20.png',
        answerIndex: 2
      },
      {
        id: 21,
        text: 'According to the law in Alberta, it is the driver\'s responsibility to ensure that all passengers under what age are properly restrained in the vehicle?:',
        text_vi: 'Theo luật pháp ở Alberta, tài xế có trách nhiệm đảm bảo rằng tất cả hành khách dưới bao nhiêu tuổi được giữ an toàn trong xe?:',
        options: ['18 years', '24 years', '21 years', '16 years'],
        options_vi: ['18 tuổi', '24 tuổi', '21 tuổi', '16 tuổi'],
        img: null ,
        answerIndex: 3
      },
      {
        id: 22,
        text: 'When parallel parking, the vehicle\'s wheels closest to the curb must be within what maximum distance?',
        text_vi: 'Khi đỗ xe song song, bánh xe gần lề nhất của xe phải ở trong khoảng cách tối đa bao nhiêu?',
        options: ['80 centimetres from the curb', '30 centimetres from the curb', '10 centimetres from the curb', '50 centimetres from the curb'],
        options_vi: ['80 cm từ lề', '30 cm từ lề', '10 cm từ lề', '50 cm từ lề'],
        img: null ,
        answerIndex: 3
      },
      {
        id: 23,
        text: 'Who is responsible and legally obligated to report any medical condition, change in health, or physical disability that may affect a driver\'s ability to drive',
        text_vi: 'Ai chịu trách nhiệm và bắt buộc theo pháp luật phải báo cáo bất kỳ tình trạng y tế, thay đổi sức khỏe hoặc khuyết tật thể chất nào có thể ảnh hưởng đến khả năng lái xe của tài xế',
        options: ['The driver\'s employer', 'The driver', 'The driver\'s doctor', 'The driver\'s insurance company'],
        options_vi: ['Nhà tuyển dụng của tài xế', 'Tài xế', 'Bác sĩ của tài xế', 'Công ty bảo hiểm của tài xế'],
        img: null ,
        answerIndex: 1
      },
      {
        id: 24,
        text: 'This sign indicates:',
        text_vi: 'Biển báo này biểu thị:',
        options: ['Road narrows, left', 'Two-way traffic', 'Divided highway ends', 'Obstruction – keep left'],
        options_vi: ['Đường hẹp lại, sang trái', 'Giao thông hai chiều', 'Đường cao tốc chia hết', 'Chướng ngại – giữ bên trái'],
        img: '/assets/24.png',
        answerIndex: 0
      },
      {
        id: 25,
        text: 'This sign indicates:',
        text_vi: 'Biển báo này biểu thị:',
        options: ['Rumble strips', 'Construction zone', 'Bump', 'Pavement ends'],
        options_vi: ['Sọc gợn sóng', 'Khu xây dựng', 'Gồ ghề', 'Nền đường kết thúc'],
        img: '/assets/25.png',
        answerIndex: 2
      },
      {
        id: 26,
        text: 'Under the Graduated Driver Licensing program, what is the minimum amount of time that a person must serve as a probationary Class 5 driver?',
        text_vi: 'Theo chương trình Cấp phép Lái xe Theo bậc, khoảng thời gian tối thiểu mà một người phải làm tài xế Class 5 thử nghiệm là bao lâu?',
        options: ['6 months', '18 months', '2 years', '1 year'],
        options_vi: ['6 tháng', '18 tháng', '2 năm', '1 năm'],
        img: null , 
        answerIndex: 2
      },
      {
        id: 27,
        text: 'A large "X" painted on the pavement indicates:',
        text_vi: 'Một chữ "X" lớn được sơn trên nền đường biểu thị:',
        options: ['Construction ahead', 'The traffic lane is ending', 'Railway crossing ahead', 'Wild animal crossing ahead'],
        options_vi: ['Xây dựng phía trước', 'Làn giao thông sắp kết thúc', 'Đường ray phía trước', 'Động vật hoang dã băng qua phía trước'],
        img: null , 
        answerIndex: 2
      },
      {
        id: 28,
        text: 'A driver is required to report all collisions to the police when persons have been injured or killed, or when combined damage to all vehicles or property is more than:',
        text_vi: 'Tài xế phải báo cáo tất cả các vụ va chạm cho cảnh sát khi có người bị thương hoặc tử vong, hoặc khi thiệt hại kết hợp cho tất cả các xe hoặc tài sản lớn hơn:',
        options: ['750', '1000', '250', '500'],
        options_vi: ['750', '1000', '250', '500'],
        img: null , 
        answerIndex: 1
      },
      {
        id: 29,
        text: 'When a driver is stopping behind another vehicle in traffic',
        text_vi: 'Khi tài xế dừng phía sau một chiếc xe khác trong giao thông',
        options: ['Remain a minimum of 10 metres from the vehicle ahead', 'Allow sufficient space to move into another lane without reversing', 'Maintain sufficient space as determined by the 2-second rule', 'Keep back approximately 1 metre from the rear bumper of the vehicle ahead'],
        options_vi: ['Giữ khoảng cách tối thiểu 10 mét từ xe phía trước', 'Để lại đủ khoảng trống để di chuyển vào làn khác mà không cần lùi xe', 'Duy trì khoảng cách đủ như được xác định bởi quy tắc 2 giây', 'Giữ khoảng cách khoảng 1 mét từ cản nước phía sau của xe phía trước'],
        img: null , 
        answerIndex: 1
      },
      {
        id: 30,
        text: 'If another vehicle is following too close, what should a driver do?',
        text_vi: 'Nếu một chiếc xe khác đang theo quá gần, tài xế nên làm gì?',
        options: ['Slow down gradually and encourage the other vehicle to pass', 'Press hard on the brake pedal', 'Increase speed to 10 km/h above the posted speed limit', 'Activate the four-way flashers'],
        options_vi: ['Giảm tốc độ dần dần và khuyến khích xe khác vượt qua', 'Nhấn mạnh vào bàn đạp phanh', 'Tăng tốc độ 10 km/h so với giới hạn tốc độ được đăng', 'Kích hoạt đèn gắp nháy bốn chiều'],
        img: null , 
        answerIndex: 0
      },
    ]
  },
  {
    id: 2,
    title: 'Mock Test 2',
    description: 'Focus on vehicle operation and safe driving techniques',
    questions: [
      {
        id: 1,
        text: 'When recovering from a skid, a driver should:',
        options: ['Accelerate and steer in the opposite direction of the skid', 'Brake and counter-steer', 'Steer in the direction the driver wants the front of the vehicle to go', 'Brake and hold firmly on the steering wheel'],
        img: null, 
        answerIndex: 2
      },
      {
        id: 2,
        text: 'A "slow-moving vehicle" sign must be displayed on the rear of any vehicle that normally travels at speeds less than:',
        options: ['50 km/h', '40 km/h', '70 km/h', '60 km/h'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 3,
        text: 'A driver attempting to turn left at a steady green traffic light',
        options: ['Has the right-of-way over oncoming traffic', 'Must stop before the pedestrian crosswalk line, then proceed', 'Has the right-of-way over pedestrians', 'Must not cross the path of an approaching vehicle unless it is safe'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 4,
        text: 'A "Weave Zone" is best described as:',
        options: ['A place on a highway where the entrance and exit lanes are close together, and vehicles that are slowing to exit the highway must drive between vehicles that are accelerating to enter the highway', 'An area on the highway that is used for emergency parking', 'A place where the highway has a series of curves that require the driver to slow down', 'A limited access area on a highway where a driver can legally back their vehicle when they miss their exit'],
        img: null, 
        answerIndex: 0
      },
      {
        id: 5,
        text: 'A road test will be refused by a driver examiner if:',
        options: ['The vehicle has a seating capacity greater than 7', 'The vehicle is registered as a farm vehicle', 'The vehicle is a rental vehicle', 'The vehicle is not mechanically safe'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 6,
        text: 'Is a driver allowed to exceed the speed limit when passing another vehicle?',
        options: ['Only when passing more than one vehicle at a time', 'Yes, but not more than 10 km/h over the speed limit', 'Yes, on primary highways only', 'No, it is never permitted'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 7,
        text: 'This sign indicates:',
        options: ['Children playing in residential area', 'Pedestrian crosswalk ahead', 'School area', 'Playground zone'],
        img: '/assets/37.png', 
        answerIndex: 2
      },
      {
        id: 8,
        text: 'The speed limit in a construction zone must be obeyed:',
        options: ['Only during daylight hours', 'Only when a flag person is posted nearby', 'At all times', 'Only when construction workers are present'],
        img: null, 
        answerIndex: 2
      },
      {
        id: 9,
        text: 'In a vehicle that does not have anti-lock brakes, threshold braking refers to:',
        options: ['Applying an even braking force to the point just before the wheels lock, and easing off slightly if the wheels lock', 'Pumping the brake pedal repeatedly until the vehicle comes to a stop', 'Releasing pressure on the brake pedal, then reapplying pressure until the wheels lock', 'Applying enough force to the brake pedal to lock the wheels and keep them locked'],
        img: null, 
        answerIndex: 0
      },
      {
        id: 10,
        text: 'When a driver\'s vehicle is approached by an emergency vehicle sounding a siren, from any direction on a two-way road, the driver must:',
        options: ['Continue at a reduced speed and allow sufficient space for the emergency vehicle to pass', 'Turn on their four-way hazard lights', 'Stop only when the emergency vehicle has difficulty in passing', 'Drive as close as possible to the right curb or edge of the road and stop'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 11,
        text: 'The recommended braking procedure to bring a vehicle to a normal, smooth stop is:',
        options: ['Continually increase brake pressure until the wheels lock', 'Shift the vehicle into neutral and apply steady pressure to the brake pedal until the vehicle comes to a stop', 'Pump the brake pedal smoothly until the vehicle stops', 'Apply brake pressure, ease off slightly just before the vehicle stops, then re-apply sufficient pressure to stop'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 12,
        text: 'In Alberta, the law requires that seat belts must be worn:',
        options: ['Only while carrying passengers', 'Properly at all times', 'Only when driving at highway speeds ', 'Only when driving in the city'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 13,
        text: 'This sign indicates:',
        options: ['Heavy trucks only', 'Do not pass', 'No vehicles allowed ', 'Do not enter'],
        img: '/assets/43.png',
        answerIndex: 1
      },
      {
        id: 14,
        text: 'A driver entering a traffic circle:',
        options: ['Must yield to traffic on the right', 'Must yield to vehicles in the traffic circle', 'Has the right-of-way ', 'Must use the courtesy rule and yield to the vehicle that arrived first'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 15,
        text: 'A deceleration lane is:',
        options: ['A lane where vehicles reduce speed when exiting a highway', 'The right lane of a four-lane highway for use by slower moving vehicles', 'The lane immediately to the right of a solid yellow line on a highway', 'A lane on hills for use by slower moving vehicles'],
        img: null, 
        answerIndex: 0
      },
      {
        id: 16,
        text: 'When turning left from a two-way road onto a one-way road, what lane should the vehicle enter?',
        options: ['The lane immediately to the right of centre', 'The lane nearest the curb on the left side of the one-way road', 'The centre lane of the one-way road', 'The right lane of the one-way road'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 17,
        text: 'When two vehicles approach an uncontrolled "T" intersection at right angles to each other at approximately the same time:',
        options: ['The vehicle on the left must yield the right-of-way', 'The vehicle on the left has the right-of-way', 'The vehicle going straight through always has the right-of-way', 'Both vehicles must stop'],
        img: null, 
        answerIndex: 0
      },
      {
        id: 18,
        text: 'Unless otherwise permitted, what lane must a driver be in to turn left from a one-way road?',
        options: ['The lane to the right of centre', 'The left lane nearest the left curb', 'The lane closes to the right curb', 'The centre lane'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 19,
        text: 'Which statement describes the steps required to reverse in a straight line?',
        options: ['Keep both hands on the steering wheel and constantly use the inside rear-view mirror for guidance', 'Place the right hand at the top of the steering wheel, look over the left shoulder and use the outside left rear-view mirror', 'Place the left hand at the top of the steering wheel and look over the right shoulder through the rear window', 'Place the left hand at the bottom of the steering wheel and use both outside mirrors'],
        img: null, 
        answerIndex: 2
      },
      {
        id: 20,
        text: 'An acceleration lane is:',
        options: ['A lane with broken line markings', 'A lane on hills, designated for faster moving vehicles', 'The left lane of a four-lane highway, for use when passing slow moving vehicles', 'A lane in a merge area for use by vehicles entering the highway'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 21,
        text: 'This sign indicates:',
        options: ['Lane ends, loss of right lane', 'Added lane (free flow)', 'Curve right', 'Dual turn lane ahead'],
        img: '/assets/50.png',
        answerIndex: 0
      },
      {
        id: 22,
        text: 'Under the Graduated Driver Licensing program, a learner with a Class 7 licence is not permitted to drive a vehicle between the hours of:',
        options: ['9:00 A.M. and 5:00 P.M.', 'Midnight and 5:00 A.M.', '10:00 P.M. and 6:00 A.M.', 'Midnight and 7:00 A.M.'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 23,
        text: 'What does a flashing yellow traffic light mean?',
        options: ['The traffic light will turn green', 'Stop until the light stops flashing', 'The traffic light will turn red', 'Proceed with caution'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 24,
        text: 'Unless otherwise posted, the school zone speed limits are in effect on school days during the following hours:',
        options: ['8:30 A.M. to 1 hour after sunset', '8:00 A.M. to 9:30 A.M., 11:30 A.M. to 1:30 P.M. and 3:00 P.M. to 4:30 P.M.', '8:30 A.M. to 9:30 A.M., 12:00 P.M. to 1:00 P.M. and 3:30 P.M. to 4:00 P.M.', '8:00 A.M. to 4:30 P.M.'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 25,
        text: 'This sign indicates:',
        options: ['Playground zone', 'Pedestrian crosswalk', 'Designated school bus stop', 'School zone'],
        img: '/assets/55.png',
        answerIndex: 1
      },
      {
        id: 26,
        text: 'When driving in the right lane on a highway, what should a driver do if another vehicle attempts to merge from an acceleration lane on the right?',
        options: ['Stop to allow the other vehicle in', 'Accelerate to close any gap in the traffic flow', 'Move into the left lane if it is safe to do so, or be prepared to adjust speed', 'Insist that the other vehicle yield the right-of-way'],
        img: null, 
        answerIndex: 2
      },
      {
        id: 27,
        text: 'Which direction should a vehicle\'s front wheels be turned when parked uphill on a two-way road with a curb?',
        options: ['Parallel to the curb', 'To the left', 'To the right', 'Straight ahead'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 28,
        text: 'When approaching the rear of a stopped school bus that has its alternately flashing red lights activated, a driver must:',
        options: ['Sound the horn to alert any pedestrians and pass at a slow rate of speed', 'Stop behind the bus and wait until the alternating red lights stop flashing', 'Move to the left lane, reduce speed to 30 km/h and pass cautiously', 'Stop behind the bus, look carefully for pedestrians and, if clear, drive past the bus slowly'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 29,
        text: 'When travelling in urban areas, drivers should scan the road approximately:',
        options: ['25 to 30 seconds ahead', '12 to 15 seconds ahead', '20 to 30 seconds ahead', '1 to 6 seconds ahead'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 30,
        text: 'This sign indicates:',
        options: ['T intersection', 'Traffic lane ends', 'Concealed intersection', 'Trucks entering highway ahead'],
        img: '/assets/60.png', 
        answerIndex: 0
      },
    ]
  },
  {
    id: 3,
    title: 'Mock Test 3',
    description: 'Advanced road situations and traffic signs',
    questions: [
      {
        id: 1,
        text: 'This sign indicates:',
        options: ['Winding road ahead', 'Weave zone ahead', 'Slippery when wet', 'Lane changing permitted'],
        img: '/assets/61.png', 
        answerIndex: 0
      },
      {
        id: 2,
        text: 'Before leaving a parallel parking space on the right side of a road:',
        options: ['Turn on the right signal', 'Shoulder check to the left', 'Shoulder check to the right', 'Use an arm signal straight out and up'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 3,
        text: 'When approaching the top of a hill on a two-lane highway:',
        options: ['Exceeding the speed limit is permitted', 'Flash the headlights to warn oncoming vehicles', 'Stay to the right portion of the lane', 'Keep close to the centre line to prevent others from passing'],
        img: null, 
        answerIndex: 2
      },
      {
        id: 4,
        text: 'Playground zones are in effect:',
        options: ['From 8:30 A.M. to 1 hour after sunset', 'From 8:00 A.M. to 8:00 P.M.', 'During daylight hours and until 11:00 P.M.', 'Only when school lets out at noon and after 4:30 P.M.'],
        img: null, 
        answerIndex: 0
      },
      {
        id: 5,
        text: 'This sign indicates:',
        options: ['"T" intersection', 'Winding road ahead', 'Merging traffic', 'Road narrows to the right'],
        img: '/assets/65.png', 
        answerIndex: 2
      },
      {
        id: 6,
        text: 'According to the Basic Licence Driver\'s Handbook, most skids are the result of:',
        options: ['Bad brakes', 'Icy roads', 'Bad tires', 'Driver error'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 7,
        text: 'How close can a driver legally park a vehicle to a Stop sign?',
        options: ['10 metres', '5 metres', '3 metres', '1.5 metres'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 8,
        text: 'Parking in a space reserved for persons with disabilities is permitted:',
        options: ['When all other parking spaces are filled', 'While the driver is waiting in the vehicle ', 'When a driver stops for less than 5 minutes', 'When the vehicle has a proper identifying placard or licence plate'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 9,
        text: 'At what minimum distance must headlights be dimmed at night when approaching another vehicle from behind?',
        options: ['60 metres', '300 metres ', '150 metres', '100 metres'],
        img: null, 
        answerIndex: 2
      },
      {
        id: 10,
        text: 'When are dual turns permitted at an intersection?',
        options: ['Only when turning from a one-way road onto a one-way road', 'Only when indicated by pavement markings or traffic control signs ', 'Any time there are at least 2 lanes on the road being entered', 'Only when the road has 6 or more lanes'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 11,
        text: 'This sign indicates:',
        options: ['Through lane only', 'Only when indicated by pavement markings or traffic control signsPassing permitted ', 'No turns permitted', 'Two-way traffic'],
        img: '/assets/71.png', 
        answerIndex: 3
      },
      {
        id: 12,
        text: 'Under the Graduated Driver Licensing program, a learner with a Class 7 operator\'s license is suspended when they accumulate',
        options: ['15 demerits', '12 demerits', '8 demerits', '7 demerits'],
        img: null, 
        answerIndex: 0
      },
      {
        id: 13,
        text: 'Speed limit signs indicate:',
        options: ['The speed you should travel under all driving conditions', 'The minimum speed permitted on all highways', 'The maximum speed permitted when conditions are favourable', 'The maximum speed permitted except when passing'],
        img: null, 
        answerIndex: 2
      },
      {
        id: 14,
        text: 'An "uncontrolled intersection":',
        options: ['Has a flashing yellow light for one direction of traffic and a flashing red light for the other direction of traffic', 'Has traffic signs but no traffic control signal lights ', 'Has no traffic control signal lights or traffic signs', 'Has Yield signs but no Stop signs'],
        img: null, 
        answerIndex: 2
      },
      {
        id: 15,
        text: 'This sign indicates:',
        options: ['Sharp left curve in the road ahead', 'Left turns are prohibited ', 'Vehicles may turn left or go straight', 'Double lane left turn'],
        img: '/assets/75.png', 
        answerIndex: 3
      },
      {
        id: 16,
        text: 'When facing a Merge sign a driver should:',
        options: ['Stop at the entrance to the other highway and wait until a gap in traffic occurs before proceeding', 'Watch for a gap in traffic on the highway they are entering, adjust to highway speed in the acceleration lane and blend in smoothly', 'Stop and yield the right-of-way to traffic already on the highway', 'Reduce speed and proceed with caution'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 17,
        text: 'In reduced visibility due to fog, smoke or snow, use the:',
        options: ['Park lights', 'Headlights on high beam', 'Headlights on low beam', 'Daytime running lights'],
        img: null, 
        answerIndex: 2
      },
      {
        id: 18,
        text: 'This sign indicates:',
        options: ['Emergency vehicles entering roadway', 'The designated lane is closed', 'Railway crossing', 'Daytime running lightsDo not enter'],
        img: '/assets/78.png', 
        answerIndex: 2
      },
      {
        id: 19,
        text: 'Is a driver allowed to turn right at a red traffic control light?',
        options: ['Yes, but only when a sign permits such a turn', 'Yes, if the driver reduces speed and there is no traffic or pedestrian in the intersection, and no sign that prohibits such a turn', 'Yes, if the driver stops and there is no traffic, pedestrian or sign that prohibits such a turn', 'No, right turns on a red traffic light are never permitted'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 20,
        text: 'This sign indicates:',
        options: ['Lane is reserved for use by the specified vehicles', 'One-way traffic only', 'Car pool vehicles only', 'Lane can be used for dangerous goods vehicles'],
        img: '/assets/80.png', 
        answerIndex: 0
      },
      {
        id: 21,
        text: 'When a vehicle is stopped to allow a pedestrian to cross the road, other vehicles that are approaching from the rear:',
        options: ['May pass the stopped vehicle if there is no oncoming traffic that may impede passing safely', 'Must not pass the stopped vehicle. It is illegal', 'May pass the stopped vehicle when eye contact is made with the pedestrian and the pedestrian stops', 'May pass the stopped vehicle when the pedestrian crossing signal has changed to "Don\'t Walk"'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 22,
        text: 'When a head restraint is raised to the proper position, the centre of the head restraint is:',
        options: ['Level with the top of the ears', 'Level with the top of the shoulders', 'Level with the neck', 'Level with the top of the head'],
        img: null, 
        answerIndex: 0
      },
      {
        id: 23,
        text: 'This sign indicates:',
        options: ['School zone ahead', 'Caution log trucks turning', 'Traffic control signal advance warning', 'Pedestrian crosswalk ahead'],
        img: '/assets/83.png', 
        answerIndex: 2
      },
      {
        id: 24,
        text: 'When a "PASSING LANE AHEAD" sign is posted, the driver of a slower moving vehicle should:',
        options: ['Use the right lane and reduce their speed to half the posted speed limit', 'Use the left lane only', 'Increase speed', 'Move into the right lane when safe'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 25,
        text: 'When approaching the rear of a school bus that is displaying alternating flashing amber lights, a driver should:',
        options: ['Be prepared to stop as this is a warning that the alternating flashing red lights will come on once the bus has stopped', 'Be prepared to stop as this could be a warning that there is a collision ahead and the traffic flow has stopped', 'Stop immediately because the school bus is loading or unloading students', 'Use caution as the school bus is approaching a railroad crossing and is about to stop'],
        img: null, 
        answerIndex: 0
      },
      {
        id: 26,
        text: 'In the Basic Licence Driver\'s Handbook, "nighttime" is defined as the period of time:',
        options: ['Beginning 1 hour before sunset and ending 1 hour after the following sunrise', 'Beginning at sunset and ending at the following sunrise', 'Between 7:00 P.M. and 7:00 A.M.','Beginning 1 hour after sunset and ending 1 hour before the following sunrise'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 27,
        text: 'This sign indicates:',
        options: ['No through traffic or right turns', 'Turn left or go straight through', 'Turn from a one-way road onto a one-way road','Straight through or right turn'],
        img: '/assets/87.png', 
        answerIndex: 3
      },
      {
        id: 28,
        text: 'A vehicle exiting a parking lot onto a roadway:',
        options: ['Must stop only if there is a Stop sign', 'Must come to a complete stop', 'Must stop before crossing the sidewalk only if there are predestrians present','Is not required to stop'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 29,
        text: 'When approaching a railway crossing that has the flashing red light and bell activated:',
        options: ['Cross the tracks if the train is a minimum of 250 metres away', 'Reduce speed, check for trains, and then proceed across the tracks', 'Do not stop and do not change gears while crossing the tracks','Stop at least 5 metres from the nearest rail until the train has passed'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 30,
        text: 'The recommended method for travelling through a curve on a highway is:',
        options: ['Reduce speed before the curve, stay in the lane and gently accelerate after entering the curve', 'Maintain speed before the curve, brake in the curve, look ahead and accelerate out of the curve', 'Cover the brake pedal before the curve, counter-steer toward the outside of the lane and accelerate when exiting','Accelerate before the curve, cover the brake pedal in the curve and accelerate after leaving the curve'],
        img: null, 
        answerIndex: 0
      },
    ]
  },
  {
    id: 4,
    title: 'Mock Test 4',
    description: 'Parking, pedestrians, and special situations',
    questions: [
      {
        id: 1,
        text: 'This sign indicates:',
        options: ['Yield the right-of-way to pedestrians and traffic', 'Dangerous goods vehicle placard: flammable gas','Slow moving vehicle','Warning, Yield sign ahead'],
        img: '/assets/91.png', 
        answerIndex: 2
      },
      {
        id: 2,
        text: 'Why is it not safe to pass a loaded log-haul truck that is turning?',
        options: ['The driver of the truck needs to fully concentrate on the turn and does not need the added responsibility of a passing vehicle', 'Loaded log-haul trucks obey the 6-second rule for turns','A danger zone exists as the overhang of the logs from the tail end of the truck could block all the lanes on a highway during the turn','It is illegal to do so'],
        img: null, 
        answerIndex: 2
      },
      {
        id: 3,
        text: 'This sign indicates:',
        options: ['Playground zone ahead', 'Pedestrian crossing ahead','School bus stop ahead','School zone ahead'],
        img: '/assets/93.png', 
        answerIndex: 2
      },
      {
        id: 4,
        text: 'When encountering a funeral processions that is crossing an intersection:',
        options: ['Sound the horn before proceeding', 'Proceed through the funeral procession only when there is sufficient space between vehicles','Yield the right-of-way and do not break through the procession','Flash the high beam headlights before proceeding'],
        img: null, 
        answerIndex: 2
      },
      {
        id: 5,
        text: 'If the vehicle\'s right tires travel off the paved portion of the roadway:',
        options: ['Apply the brakes and counter-steer to return to the paved portion of the roadway', 'Keep a firm grip on the steering wheel, ease off the gas pedal, and then gradually return to the paved portion of the roadway','Accelerate slightly, then turn the steering wheel sharply to return to the paved portion of the roadway','Move the vehicle completely off the paved portion, then steer back onto the paved portion of the roadway'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 6,
        text: 'The sign indicates:',
        options: ['A school zone', 'School crosswalk ahead','Playground zone','Pedestrian activated lights ahead'],
        img: '/assets/96.png', 
        answerIndex: 1
      },
      {
        id: 7,
        text: 'When completing an angle park, the vehicle\'s front wheel must be within what maximum distance from the nearest curb?',
        options: ['100 cm', '50 cm','25 cm','75 cm'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 8,
        text: 'In an urban area, when a pedestrian is standing at a crosswalk with their arm raised at approximately right angles to their body and pointing to the opposite curb, what does this mean?',
        options: ['Drivers must stop and yield to the pedestrian', 'The pedestrian is visually impaired and needs assistance to cross the road','Drivers do not have to yield to the pedestrian until they step off the curb','Drivers should reduce speed to 20 km/h and be cautious when passing the pedestrian'],
        img: null, 
        answerIndex: 0
      },
      {
        id: 9,
        text: 'This sign indicates:',
        options: ['Pavement ends', 'Construction zone ahead','Dead end','Hazard marker'],
        img: '/assets/99.png', 
        answerIndex: 2
      },
      {
        id: 10,
        text: 'This sign indicates:',
        options: ['Divided highway ends', 'Divided highway begins','Obstruction – pass on the left','Two-way traffic'],
        img: '/assets/100.png', 
        answerIndex: 1
      },
      {
        id: 11,
        text: 'When approaching an intersection displaying a steady yellow traffic light:',
        options: ['Proceed since the light is about to turn green', 'Yield to vehicles on the right','Stop before the intersection unless the stop cannot be made in safety','Increase speed to clear the intersection'],
        img: null, 
        answerIndex: 2
      },
      {
        id: 12,
        text: 'A solid yellow line together with a broken yellow line marked on the centre of a highway means:',
        options: ['The road narrows ahead', 'If the solid line is on your side, passing is permitted','If the broken line is on your side, passing is not permitted','If the broken line is on your side, passing is permitted'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 13,
        text: 'At 9:00 A.M. on a school day, what is the maximum speed permitted in a school zone in a rural area, unless otherwise posted?',
        options: ['50 km/h', '20 km/h','40 km/h','30 km/h'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 14,
        text: 'On a two-lane highway, when passing other vehicles travelling in the same direction, a driver:',
        options: ['Should pass on the left when safe', 'Should pass on the right when safe','Should always travel 30 km/h faster than the vehicle being passed','Should not pull out to pass until they are within 3 metres of the vehicle being passed'],
        img: null, 
        answerIndex: 0
      },
      {
        id: 15,
        text: 'This sign indicates:',
        options: ['Off-road facilities', 'Hospital services','Hotel services','Primary highway route marker'],
        img: '/assets/105.png', 
        answerIndex: 1
      },
      {
        id: 16,
        text: 'What minimum distance from a fire hydrant must a vehicle be parked?',
        options: ['3 metres', '4 metres','2 metres','5 metres'],
        img: null, 
        answerIndex: 3
      },
      {
        id: 17,
        text: 'This sign indicates:',
        options: ['Construction sign, flag person ahead', 'Construction sign, detour ahead','Caution, falling rock ahead','Construction sign, people working ahead'],
        img: '/assets/107.png', 
        answerIndex: 3
      },
      {
        id: 18,
        text: 'If a driver is being followed by a vehicle that is attempting to pass on a two-way road, the driver should:',
        options: ['Stay in the lane and move to the left portion of the lane', 'Stay in the lane and move to the right portion of the lane','Turn on the left signal and stay in the lane','Turn on the right signal and drive in the parking lane'],
        img: null, 
        answerIndex: 1
      },
      {
        id: 19,
        text: 'Unless otherwise posted, what is the basic speed limit outside a city, town or village on a primary highway?',
        options: ['100 km/h', '80 km/h', '60 km/h', '50 km/h'],
        img: null,
        answerIndex: 0
      },
      {
        id: 20,
        text: 'When backing a passenger vehicle to the left, a driver should:',
        options: ['Look in the inside rear-view mirror and make steering adjustments as necessary', 'Look over the right shoulder with occasional glances to the front', 'Look over the left shoulder with occasional glances to the front', 'Without shoulder checking, use the inside and outside rear-view mirrors to ensure the best view to the rear and both sides of the vehicle'],
        img: null,  
        answerIndex: 2
      },
      {
        id: 21,
        text: 'When approaching an intersection and facing a traffic control light that is showing a green right-turn arrow and a red light, a driver',
        options: ['Must stop and wait for a green light before turning in the direction of the arrow', 'May go straight through the intersection without stopping', 'May proceed when safe, without stopping, in the direction of the arrow', 'May turn left without stopping'],
        img: null,
        answerIndex: 2
      },
      {
        id: 22,
        text: 'Alberta has a demerit point system where a fully licenced (non-learner, non-probationary) driver is suspended when they accumulate',
        options: ['15 points', '8 points', '5 points', '12 points'],
        img: null,
        answerIndex: 0
      },
      {
        id: 23,
        text: 'When passing a large truck on a two-way highway, a driver should',
        options: ['Leave extra room before returning to their lane', 'Return to their lane when signalled by the truck\'s headlights', 'Return to their lane when the truck is no longer visible in any of their rear-view mirrors', 'Return to their lane once they have cleared the truck\'s front bumper'],
        img: null,
        answerIndex: 0
      },
      {
        id: 24,
        text: 'Which statement best describes the steps for turning right at a red traffic light?',
        options: ['Right turns on a red traffic light are never permitted', 'Signal and make sure there is no sign prohibiting the turn, stop, look left and right, yield the right-of-way, then proceed', 'Reduce speed before the turn, look right for cyclists, signal and proceed', 'Signal and reduce speed before the turn, look left, yield to vehicles and proceed'],
        img: null,
        answerIndex: 1
      },
      {
        id: 25,
        text: 'This sign indicates:',
        options: ['Route for vehicles over 4500 kg', 'Route for slow moving vehicles', 'Reserved lane for buses', 'Dangerous goods route'],
        img: 'assets/7.png',
        answerIndex: 3
      },
      {
        id: 26,
        text: 'A single solid white line between driving lanes in an urban area means',
        options: ['It is a line separating traffic travelling in opposite directions', 'Traffic on the right is moving faster than traffic on the left', 'Lane changing is not permitted', 'Lane change is permitted'],
        img: null,
        answerIndex: 2
      },
      {
        id: 27,
        text: 'A "parking lane" as defined in the Basic Licence Driver\'s Handbook is:',
        options: ['A lane closest to the curb, where parking is permitted but there are no meters', 'All of these responses are correct', 'That portion of a primary highway between the edge of the roadway to the right of the direction of traffic and the nearest solid white line, not being the centre line, marked on the roadway', 'A lane immediately beside a row of parking meters in an urban area'],
        img: null,
        answerIndex: 2
      },
      {
        id: 28,
        text: 'Shoulder checking means:',
        options: ['Glancing towards the blind spot in the direction the driver intends to move', 'Glancing into the left outside mirror', 'Glancing into both the inside and outside mirrors', 'Glancing into the right outside mirror'],
        img: null,
        answerIndex: 0
      },
      {
        id: 29,
        text: 'This sign indicates:',
        options: ['Off-road facilities ahead', 'Slippery when wet', 'Uneven pavement', 'Detour ahead'],
        img: 'assets/11.png',
        answerIndex: 2
      },
      {
        id: 30,
        text: 'A traffic-lane control light with an illuminated red "X" means:',
        options: ['Prepare for an emergency vehicle travelling in that lane', 'Reduce speed to below 30 km/h', 'Use that lane only for the purpose of making left turns', 'Travel is not permitted in that lane'],
        img: 'assets/12.png',
        answerIndex: 3
      },
    ]
  },
  {
    id: 5,
    title: 'Mock Test 5',
    description: 'Comprehensive review and challenging scenarios',
    questions: [
      {
        id: 1,
        text: 'Does a parent have the right to withdraw a previously given "parental consent" for someone under 18 years of age with respect to an operator\'s licence?',
        options: ['Yes, provided the person is still under the age of 18 and is not self-supporting or married', 'Yes, provided that both parents verbally agree to withdraw the consent at a registry office', 'No, once it is given it remains in effect until the person reaches 18 years of age', 'No, but another consent form must be signed by both parents after a licence suspension'],
        img: null,
        answerIndex: 0
      },
      {
        id: 2,
        text: 'When approaching a Yield sign, you must:',
        options: ['Yield the right-of-way to traffic not facing the sign and all pedestrians in the intersection', 'Always sound the horn to warn other traffic within the intersection', 'Expect all other vehicles to yield the right-of-way to you', 'Come to a stop and proceed after looking to the right and left'],
        img: null,
        answerIndex: 0
      },
      {
        id: 3,
        text: 'The term "over-driving" your headlights at night means:',
        options: ['The driver cannot see clearly for 1000 metres', 'The low beam headlights are not set properly', 'The driver is travelling at a speed which would not permit them to see an object in time to stop', 'The driver has had the headlights on for too long a time'],
        img: null,
        answerIndex: 2
      },
      {
        id: 4,
        text: 'Under the Graduated Driver Licensing program, a driver will receive 2 demerits:',
        options: ['For having more passengers than there are seat belts', 'For not wearing a seat belt securely fastened', 'For not wearing a seat belt', 'For not wearing a seat belt properly adjusted'],
        img: null,
        answerIndex: 0
      },
      {
        id: 5,
        text: 'Using the 2-second rule to judge a safe following distance when driving:',
        options: ['Is more accurate on rural highways than in urban centres', 'Is not accurate at speeds greater than 100 km/h', 'Is accurate at any speed', 'Is not accurate at speeds lower than 30 km/h'],
        img: null,
        answerIndex: 2
      },
      {
        id: 6,
        text: 'This sign indicates:',
        options: ['Traffic entering from the right', 'Winding road ahead', 'Curve right', 'Concealed intersection on the right'],
        img: '/assets/18.png',
        answerIndex: 2
      },
      {
        id: 7,
        text: 'A driver approaching a flashing red traffic light must:',
        options: ['Stop and wait for the flashing green light', 'Reduce speed and proceed with caution', 'Stop and proceed only when safe to do so', 'Stop until the signal light turns green'],
        img: null,
        answerIndex: 2
      },
      {
        id: 8,
        text: 'This sign indicates:',
        options: ['Do not enter', 'Slow moving vehicles ahead', 'Warning, Yield sign ahead', 'Warning, traffic is approaching'],
        img: '/assets/20.png',
        answerIndex: 2
      },
      {
        id: 9,
        text: 'According to the law in Alberta, it is the driver\'s responsibility to ensure that all passengers under what age are properly restrained in the vehicle?:',
        options: ['18 years', '24 years', '21 years', '16 years'],
        img: null,
        answerIndex: 3
      },
      {
        id: 10,
        text: 'When parallel parking, the vehicle\'s wheels closest to the curb must be within what maximum distance?',
        options: ['80 centimetres from the curb', '30 centimetres from the curb', '10 centimetres from the curb', '50 centimetres from the curb'],
        img: null,
        answerIndex: 3
      },
      {
        id: 11,
        text: 'Who is responsible and legally obligated to report any medical condition, change in health, or physical disability that may affect a driver\'s ability to drive',
        options: ['The driver\'s employer', 'The driver', 'The driver\'s doctor', 'The driver\'s insurance company'],
        img: null,
        answerIndex: 1
      },
      {
        id: 12,
        text: 'This sign indicates:',
        options: ['Road narrows, left', 'Two-way traffic', 'Divided highway ends', 'Obstruction – keep left'],
        img: '/assets/24.png',
        answerIndex: 0
      },
      {
        id: 13,
        text: 'This sign indicates:',
        options: ['Rumble strips', 'Construction zone', 'Bump', 'Pavement ends'],
        img: '/assets/25.png',
        answerIndex: 2
      },
      {
        id: 14,
        text: 'Under the Graduated Driver Licensing program, what is the minimum amount of time that a person must serve as a probationary Class 5 driver?',
        options: ['6 months', '18 months', '2 years', '1 year'],
        img: null,
        answerIndex: 2
      },
      {
        id: 15,
        text: 'A large "X" painted on the pavement indicates:',
        options: ['Construction ahead', 'The traffic lane is ending', 'Railway crossing ahead', 'Wild animal crossing ahead'],
        img: null,
        answerIndex: 2
      },
      {
        id: 16,
        text: 'A driver is required to report all collisions to the police when persons have been injured or killed, or when combined damage to all vehicles or property is more than:',
        options: ['750', '1000', '250', '500'],
        img: null,
        answerIndex: 1
      },
      {
        id: 17,
        text: 'When a driver is stopping behind another vehicle in traffic',
        options: ['Remain a minimum of 10 metres from the vehicle ahead', 'Allow sufficient space to move into another lane without reversing', 'Maintain sufficient space as determined by the 2-second rule', 'Keep back approximately 1 metre from the rear bumper of the vehicle ahead'],
        img: null,
        answerIndex: 1
      },
      {
        id: 18,
        text: 'If another vehicle is following too close, what should a driver do?',
        options: ['Slow down gradually and encourage the other vehicle to pass', 'Press hard on the brake pedal', 'Increase speed to 10 km/h above the posted speed limit', 'Activate the four-way flashers'],
        img: null,
        answerIndex: 0
      },
      {
        id: 19,
        text: 'When recovering from a skid, a driver should:',
        options: ['Accelerate and steer in the opposite direction of the skid', 'Brake and counter-steer', 'Steer in the direction the driver wants the front of the vehicle to go', 'Brake and hold firmly on the steering wheel'],
        img: null,
        answerIndex: 2
      },
      {
        id: 20,
        text: 'A "slow-moving vehicle" sign must be displayed on the rear of any vehicle that normally travels at speeds less than:',
        options: ['50 km/h', '40 km/h', '70 km/h', '60 km/h'],
        img: null,
        answerIndex: 1
      },
      {
        id: 21,
        text: 'A driver attempting to turn left at a steady green traffic light',
        options: ['Has the right-of-way over oncoming traffic', 'Must stop before the pedestrian crosswalk line, then proceed', 'Has the right-of-way over pedestrians', 'Must not cross the path of an approaching vehicle unless it is safe'],
        img: null,
        answerIndex: 3
      },
      {
        id: 22,
        text: 'A "Weave Zone" is best described as:',
        options: ['A place on a highway where the entrance and exit lanes are close together, and vehicles that are slowing to exit the highway must drive between vehicles that are accelerating to enter the highway', 'An area on the highway that is used for emergency parking', 'A place where the highway has a series of curves that require the driver to slow down', 'A limited access area on a highway where a driver can legally back their vehicle when they miss their exit'],
        img: null,
        answerIndex: 0
      },
      {
        id: 23,
        text: 'A road test will be refused by a driver examiner if:',
        options: ['The vehicle has a seating capacity greater than 7', 'The vehicle is registered as a farm vehicle', 'The vehicle is a rental vehicle', 'The vehicle is not mechanically safe'],
        img: null,
        answerIndex: 3
      },
      {
        id: 24,
        text: 'Is a driver allowed to exceed the speed limit when passing another vehicle?',
        options: ['Only when passing more than one vehicle at a time', 'Yes, but not more than 10 km/h over the speed limit', 'Yes, on primary highways only', 'No, it is never permitted'],
        img: null,
        answerIndex: 3
      },
      {
        id: 25,
        text: 'This sign indicates:',
        options: ['Children playing in residential area', 'Pedestrian crosswalk ahead', 'School area', 'Playground zone'],
        img: '/assets/37.png',
        answerIndex: 3
      },
      {
        id: 26,
        text: 'The speed limit in a construction zone must be obeyed:',
        options: ['Only during daylight hours', 'Only when a flag person is posted nearby', 'At all times', 'Only when construction workers are present'],
        img: null,
        answerIndex: 2
      },
      {
        id: 27,
        text: 'In a vehicle that does not have anti-lock brakes, threshold braking refers to:',
        options: ['Applying an even braking force to the point just before the wheels lock, and easing off slightly if the wheels lock', 'Pumping the brake pedal repeatedly until the vehicle comes to a stop', 'Releasing pressure on the brake pedal, then reapplying pressure until the wheels lock', 'Applying enough force to the brake pedal to lock the wheels and keep them locked'],
        img: null,
        answerIndex: 0
      },
      {
        id: 28,
        text: 'When a driver\'s vehicle is approached by an emergency vehicle sounding a siren, from any direction on a two-way road, the driver must:',
        options: ['Continue at a reduced speed and allow sufficient space for the emergency vehicle to pass', 'Turn on their four-way hazard lights', 'Stop only when the emergency vehicle has difficulty in passing', 'Drive as close as possible to the right curb or edge of the road and stop'],
        img: null,
        answerIndex: 3
      },
      {
        id: 29,
        text: 'The recommended braking procedure to bring a vehicle to a normal, smooth stop is:',
        options: ['Continually increase brake pressure until the wheels lock', 'Shift the vehicle into neutral and apply steady pressure to the brake pedal until the vehicle comes to a stop', 'Pump the brake pedal smoothly until the vehicle stops', 'Apply brake pressure, ease off slightly just before the vehicle stops, then re-apply sufficient pressure to stop'],
        img: null,
        answerIndex: 3
      },
      {
        id: 30,
        text: 'In Alberta, the law requires that seat belts must be worn:',
        options: ['Only while carrying passengers', 'Properly at all times', 'Only when driving at highway speeds ', 'Only when driving in the city'],
        img: null,
        answerIndex: 1
      },
    ]
  },
  {
    id: 6,
    title: 'Mock Test 6',
    description: 'Focus on distracted driving, school zones, and modern traffic regulations',
    questions: [
      {
        id: 1,
        text: 'What is the maximum speed limit in a school zone when children are present?',
        options: ['30 km/h', '40 km/h', '50 km/h', '20 km/h'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 2,
        text: 'Using a hand-held cell phone while driving in Alberta:',
        options: ['Is permitted if the call is brief', 'Is only prohibited on highways', 'Is prohibited and can result in a fine and demerit points', 'Is permitted if using a hands-free device'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 3,
        text: 'A Class 7 learner driver must have a blood alcohol content of:',
        options: ['0.05% or less', '0.08% or less', '0.00% (zero tolerance)', '0.02% or less'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 4,
        text: 'When driving in a playground zone, the maximum speed limit is:',
        options: ['30 km/h during posted hours', '40 km/h at all times', '50 km/h', '30 km/h at all times'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 5,
        text: 'A Class 7 learner must be accompanied by a supervising driver who:',
        options: ['Is at least 18 years old with a valid Class 5 licence for at least 2 years', 'Is at least 21 years old with any valid licence', 'Holds a Class 7 licence', 'Is at least 25 years old'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 6,
        text: 'When can a Class 7 learner driver transport passengers?',
        options: ['Never, passengers are not permitted', 'Only family members', 'Only when accompanied by a supervising driver', 'Anytime with a maximum of 2 passengers'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 7,
        text: 'The demerit point threshold for a Class 7 learner before suspension is:',
        options: ['8 points', '15 points', '12 points', '5 points'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 8,
        text: 'When approaching a school bus with flashing red lights stopped on your side of the road, you must:',
        options: ['Slow down to 30 km/h and pass carefully', 'Stop and remain stopped until the lights stop flashing', 'Stop only if children are visible', 'Proceed with caution'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 9,
        text: 'What does this sign indicate?',
        options: ['Playground zone ahead', 'School zone ahead', 'Children crossing area', 'Park entrance'],
        img: '/assets/school-zone.png',
        answerIndex: 1,
      },
      {
        id: 10,
        text: 'Texting while driving in Alberta can result in:',
        options: ['A warning for first-time offenders', 'A fine of $300 and 3 demerit points', 'Only a fine with no demerit points', 'Vehicle impoundment'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 11,
        text: 'When must headlights be turned on?',
        options: ['Only at night', 'One hour before sunset to one hour after sunrise, and when visibility is less than 150 metres', '30 minutes before sunset to 30 minutes after sunrise', 'Anytime it is raining or snowing'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 12,
        text: 'The "N" sign for new drivers must be displayed:',
        options: ['On the rear window or bumper', 'On the front windshield', 'On both front and rear', 'On the driver\'s side door'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 13,
        text: 'When driving in fog, you should:',
        options: ['Use high beam headlights', 'Use low beam headlights and reduce speed', 'Use parking lights only', 'Turn off all lights to reduce glare'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 14,
        text: 'A solid yellow line on your side of the center line means:',
        options: ['Passing is permitted with caution', 'Passing is not permitted', 'Slow moving vehicle lane', 'Construction zone ahead'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 15,
        text: 'When parking uphill with a curb, you should:',
        options: ['Turn wheels away from the curb', 'Turn wheels toward the curb', 'Leave wheels straight', 'Turn wheels in any direction'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 16,
        text: 'A flashing green light at an intersection means:',
        options: ['Proceed with caution, yielding to pedestrians', 'The light is about to turn yellow', 'Advanced green for turning', 'Pedestrian controlled crossing'],
        img: null,
        answerIndex: 3,
      },
      {
        id: 17,
        text: 'What is the minimum following distance recommended in ideal conditions?',
        options: ['1 second', '2 seconds', '3 seconds', '4 seconds'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 18,
        text: 'When changing lanes, you must:',
        options: ['Signal, check mirrors, and change lanes', 'Signal, check mirrors, shoulder check, then change lanes when safe', 'Shoulder check and change lanes', 'Signal and change lanes immediately'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 19,
        text: 'The speed limit in an alley is:',
        options: ['30 km/h', '20 km/h', '40 km/h', '50 km/h'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 20,
        text: 'If you are involved in a collision with no injuries but over $2,000 in damage, you must:',
        options: ['Report it to police immediately', 'Report it to your insurance company only', 'File a report within 24 hours', 'No report is necessary'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 21,
        text: 'When approaching a pedestrian crosswalk with a pedestrian waiting to cross:',
        options: ['Slow down and proceed if clear', 'Stop and allow the pedestrian to cross', 'Sound your horn to alert the pedestrian', 'Speed up to clear the crosswalk'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 22,
        text: 'Anti-lock braking systems (ABS) help prevent:',
        options: ['Brake wear', 'Wheel lock-up during hard braking', 'Engine stalling', 'Transmission damage'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 23,
        text: 'When driving at night, if an oncoming vehicle has bright lights, you should:',
        options: ['Flash your high beams repeatedly', 'Look toward the right edge of the road', 'Close one eye', 'Stare at the headlights'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 24,
        text: 'A yellow diamond-shaped sign indicates:',
        options: ['Regulatory information', 'Warning or caution', 'Construction zone', 'Railroad crossing'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 25,
        text: 'The primary purpose of traffic laws is to:',
        options: ['Generate revenue', 'Ensure safe and orderly movement of traffic', 'Employ police officers', 'Reduce insurance costs'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 26,
        text: 'When entering a freeway, you should:',
        options: ['Stop and wait for an opening', 'Signal and merge at a slower speed', 'Use the acceleration lane to match the speed of traffic, then merge', 'Enter immediately without signaling'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 27,
        text: 'During winter driving, the recommended following distance should be increased to:',
        options: ['3 seconds', '4 seconds or more', '2 seconds', '5 seconds minimum'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 28,
        text: 'If your vehicle begins to skid, you should:',
        options: ['Brake hard', 'Steer in the direction you want to go and ease off the accelerator', 'Accelerate to regain control', 'Turn the steering wheel opposite to the skid'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 29,
        text: 'A red circle with a line through it on a sign means:',
        options: ['Warning', 'Caution ahead', 'Prohibition or something not permitted', 'Construction zone'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 30,
        text: 'When parking downhill with a curb, turn your front wheels:',
        options: ['Away from the curb', 'Toward the curb', 'Straight', 'Either direction'],
        img: null,
        answerIndex: 1,
      },
    ]
  },
  {
    id: 7,
    title: 'Mock Test 7',
    description: 'Advanced road rules, intersections, and right-of-way situations',
    questions: [
      {
        id: 1,
        text: 'At a four-way stop, which vehicle has the right-of-way?',
        options: ['The largest vehicle', 'The vehicle that arrived first', 'The vehicle on the right', 'The vehicle going straight'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 2,
        text: 'When two vehicles arrive at an uncontrolled intersection at the same time, who has the right-of-way?',
        options: ['The vehicle on the left', 'The vehicle traveling faster', 'The vehicle on the right', 'The larger vehicle'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 3,
        text: 'A broken white line on the road means:',
        options: ['No passing allowed', 'Lane changes are permitted when safe', 'Pedestrian crossing ahead', 'Construction zone'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 4,
        text: 'When turning left at an intersection with a green light, you must:',
        options: ['Turn immediately without stopping', 'Yield to oncoming traffic and pedestrians', 'Have the right-of-way over all other vehicles', 'Wait for the advanced green arrow'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 5,
        text: 'The octagon shape is used exclusively for:',
        options: ['Yield signs', 'Stop signs', 'Speed limit signs', 'Warning signs'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 6,
        text: 'When must you yield to emergency vehicles with flashing lights and sirens?',
        options: ['Only on highways', 'Only at intersections', 'At all times, pulling over to the right when safe', 'Only if they are directly behind you'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 7,
        text: 'A traffic light is red, but a police officer signals you to proceed. You should:',
        options: ['Wait for the green light', 'Follow the officer\'s directions', 'Proceed with caution only', 'Stop and ask the officer'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 8,
        text: 'When approaching a railway crossing with flashing lights but no train is visible, you should:',
        options: ['Proceed quickly across', 'Stop and wait until the lights stop flashing', 'Slow down and look both ways', 'Sound your horn and cross'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 9,
        text: 'Unless otherwise posted, the speed limit in a residential area is:',
        options: ['30 km/h', '40 km/h', '50 km/h', '60 km/h'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 10,
        text: 'A green arrow pointing left means:',
        options: ['Left turns only when safe', 'You may proceed left without stopping', 'Yield before turning left', 'Stop before turning left'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 11,
        text: 'When parallel parking, you must park within what distance from the curb?',
        options: ['30 cm', '50 cm', '60 cm', '1 metre'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 12,
        text: 'You may not park within what distance of a fire hydrant?',
        options: ['3 metres', '5 metres', '10 metres', '15 metres'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 13,
        text: 'When being passed by another vehicle, you should:',
        options: ['Speed up to prevent passing', 'Maintain your speed and position', 'Move to the right shoulder', 'Slow down significantly'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 14,
        text: 'A white rectangular sign with black letters indicates:',
        options: ['Warning', 'Regulatory or law', 'Guidance or information', 'Construction'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 15,
        text: 'When approaching a yield sign, you must:',
        options: ['Always come to a complete stop', 'Slow down and yield to traffic with the right-of-way', 'Speed up to merge quickly', 'Stop only if other vehicles are present'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 16,
        text: 'The maximum speed limit on a secondary highway in Alberta, unless otherwise posted, is:',
        options: ['80 km/h', '100 km/h', '90 km/h', '110 km/h'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 17,
        text: 'When making a right turn, you should:',
        options: ['Turn into the left lane', 'Turn wide into the center lane', 'Turn into the right lane', 'Turn into any available lane'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 18,
        text: 'A pedestrian with a white cane is:',
        options: ['Lost and needs directions', 'Blind or visually impaired', 'A crossing guard', 'A surveyor'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 19,
        text: 'When driving in heavy rain, you should:',
        options: ['Use high beam headlights', 'Increase speed to get through quickly', 'Reduce speed and increase following distance', 'Turn on hazard lights while moving'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 20,
        text: 'You must signal your intention to turn how far in advance?',
        options: ['10 metres', '30 metres', 'At least 15 metres or 5 seconds', '50 metres'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 21,
        text: 'What does a double solid yellow line indicate?',
        options: ['Passing is permitted', 'No passing in either direction', 'Passing permitted on the right only', 'Lane change permitted'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 22,
        text: 'When parking on a hill without a curb, you should:',
        options: ['Turn wheels to the right', 'Leave wheels straight', 'Turn wheels to the left', 'Set parking brake only'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 23,
        text: 'A Class 7 licence holder is suspended if they accumulate how many demerit points?',
        options: ['5 points', '8 points', '12 points', '15 points'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 24,
        text: 'When can you pass on the right?',
        options: ['Never', 'When the vehicle ahead is turning left and there is sufficient room', 'Anytime on a multi-lane road', 'Only on one-way streets'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 25,
        text: 'If you miss your exit on a freeway, you should:',
        options: ['Back up to the exit', 'Stop and make a U-turn', 'Continue to the next exit', 'Cut across lanes quickly'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 26,
        text: 'When driving through a construction zone, you should:',
        options: ['Maintain highway speed', 'Obey posted speed limits and watch for workers', 'Speed up to clear the zone quickly', 'Change lanes frequently'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 27,
        text: 'A flashing yellow light means:',
        options: ['Stop', 'Proceed with caution', 'Speed up', 'Yield right-of-way'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 28,
        text: 'You may not park within what distance of a crosswalk?',
        options: ['3 metres', '5 metres', '10 metres', '15 metres'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 29,
        text: 'When entering a roundabout, you must:',
        options: ['Speed up to merge', 'Yield to traffic already in the roundabout', 'Stop and wait for an opening', 'Enter without yielding'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 30,
        text: 'The purpose of a shoulder check is to:',
        options: ['Check tire pressure', 'Look in the blind spot', 'Adjust mirrors', 'Check the speedometer'],
        img: null,
        answerIndex: 1,
      },
    ]
  },
  {
    id: 8,
    title: 'Mock Test 8',
    description: 'Weather conditions, night driving, and defensive driving techniques',
    questions: [
      {
        id: 1,
        text: 'Hydroplaning occurs when:',
        options: ['Tires lose contact with the road due to water buildup', 'The engine overheats', 'Brakes fail', 'Tires are over-inflated'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 2,
        text: 'Black ice is most likely to form:',
        options: ['On bridges and overpasses', 'In parking lots', 'On gravel roads', 'In residential areas'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 3,
        text: 'When driving in snow, you should:',
        options: ['Use cruise control', 'Increase following distance to 8-10 seconds', 'Use high beam headlights', 'Drive in the left lane'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 4,
        text: 'If your vehicle breaks down on a highway, you should:',
        options: ['Stay in the vehicle with doors locked', 'Move the vehicle to the shoulder and activate hazard lights', 'Stand behind the vehicle to warn others', 'Leave the vehicle in the travel lane'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 5,
        text: 'High beam headlights should be dimmed within what distance of an oncoming vehicle?',
        options: ['100 metres', '150 metres', '200 metres', '300 metres'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 6,
        text: 'When driving at night, you should:',
        options: ['Over-drive your headlights to see farther', 'Drive at a speed that allows you to stop within the distance lit by headlights', 'Use high beams at all times', 'Follow other vehicles closely to use their lights'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 7,
        text: 'Defensive driving means:',
        options: ['Driving aggressively to protect your position', 'Anticipating potential hazards and driving to avoid them', 'Honking at other drivers frequently', 'Maintaining high speeds'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 8,
        text: 'If you encounter a vehicle with headlights off at night, you should:',
        options: ['Flash your headlights once to alert them', 'Follow closely', 'Pass immediately', 'Sound your horn continuously'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 9,
        text: 'When driving in fog, you should avoid using:',
        options: ['Low beam headlights', 'Windshield wipers', 'High beam headlights', 'Turn signals'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 10,
        text: 'The safest way to exit a freeway is to:',
        options: ['Brake hard before the exit', 'Signal, move to exit lane early, then reduce speed on deceleration lane', 'Slow down in the travel lane', 'Exit without signaling'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 11,
        text: 'When your vehicle starts to skid on ice, you should:',
        options: ['Brake hard immediately', 'Steer in the direction you want to go', 'Accelerate quickly', 'Turn the wheel sharply'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 12,
        text: 'What is the legal minimum tire tread depth in Alberta?',
        options: ['1.0 mm', '1.6 mm', '2.0 mm', '3.0 mm'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 13,
        text: 'When driving behind a large truck, you should:',
        options: ['Follow closely to stay in their slipstream', 'Increase following distance as you cannot see ahead', 'Flash headlights to alert the driver', 'Pass on the right side'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 14,
        text: 'The best position for your hands on the steering wheel is:',
        options: ['10 and 2 o\'clock or 9 and 3 o\'clock', '12 o\'clock', '6 and 12 o\'clock', 'One hand at 12 o\'clock'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 15,
        text: 'What should you do if your accelerator pedal sticks?',
        options: ['Pump the accelerator', 'Shift to neutral and brake', 'Turn off the ignition immediately', 'Press harder on the accelerator'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 16,
        text: 'When sharing the road with cyclists, you should:',
        options: ['Honk to alert them of your presence', 'Pass as close as possible', 'Allow at least 1 metre of space when passing', 'Force them off the road'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 17,
        text: 'If your brakes fail while driving, you should:',
        options: ['Pump the brake pedal, downshift, and use emergency brake gradually', 'Turn off the engine', 'Swerve into a ditch', 'Pull the emergency brake hard'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 18,
        text: 'When should you check your blind spot?',
        options: ['Only when changing lanes', 'When changing lanes, merging, or turning', 'Never, mirrors are sufficient', 'Only on highways'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 19,
        text: 'The purpose of anti-lock brakes (ABS) is to:',
        options: ['Reduce brake wear', 'Allow steering control during hard braking', 'Make brakes last longer', 'Increase braking distance'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 20,
        text: 'If you are being tailgated, you should:',
        options: ['Brake suddenly to teach them a lesson', 'Speed up', 'Slow down gradually and allow them to pass', 'Change lanes abruptly'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 21,
        text: 'When driving in winter conditions, you should:',
        options: ['Use cruise control to maintain speed', 'Clear all snow and ice from windows before driving', 'Warm up the car for 30 minutes', 'Drive in 4-wheel drive at all times'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 22,
        text: 'What does "space cushion" mean?',
        options: ['Extra padding in the seat', 'Safe distance around your vehicle', 'Airbag system', 'Spare tire'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 23,
        text: 'When driving through water on the road, you should:',
        options: ['Speed up to create a bow wave', 'Slow down and test brakes afterward', 'Shift to neutral', 'Turn off the engine'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 24,
        text: 'The safest drivers are those who:',
        options: ['Drive fast to keep up with traffic', 'Are constantly alert and scan ahead', 'Focus only on the vehicle directly ahead', 'Rely solely on mirrors'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 25,
        text: 'If you feel tired while driving, you should:',
        options: ['Open the window for fresh air', 'Drink coffee and continue', 'Pull over and rest or switch drivers', 'Turn up the radio'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 26,
        text: 'When driving at night in rural areas, watch for:',
        options: ['Brighter pavement markings', 'More police patrols', 'Wildlife crossing the road', 'Fewer hazards'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 27,
        text: 'The best way to handle a tire blowout is to:',
        options: ['Brake hard immediately', 'Grip the wheel firmly, ease off the gas, and brake gently', 'Accelerate to maintain control', 'Turn sharply to the shoulder'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 28,
        text: 'When should you increase your following distance?',
        options: ['Only in winter', 'In poor weather, heavy traffic, or when being tailgated', 'Never, maintain 2 seconds always', 'Only at night'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 29,
        text: 'To avoid highway hypnosis on long trips, you should:',
        options: ['Stare at the center line', 'Take regular breaks and scan the environment', 'Drive faster to stay alert', 'Focus on one point'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 30,
        text: 'Carbon monoxide in a vehicle is most dangerous because it:',
        options: ['Has a strong smell', 'Is colorless, odorless, and can cause drowsiness or death', 'Damages the engine', 'Reduces fuel efficiency'],
        img: null,
        answerIndex: 1,
      },
    ]
  },
  {
    id: 9,
    title: 'Mock Test 9',
    description: 'GDL program, licensing requirements, and traffic violations',
    questions: [
      {
        id: 1,
        text: 'How long must you hold a Class 7 learner\'s licence before taking the Class 5 road test?',
        options: ['6 months', '1 year', 'At least 1 year', '2 years'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 2,
        text: 'A Class 5 GDL probationary driver must have a blood alcohol level of:',
        options: ['0.00%', '0.05%', '0.08%', '0.02%'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 3,
        text: 'What happens if a Class 7 driver is convicted of distracted driving?',
        options: ['Warning only', 'Fine and demerit points leading to possible suspension', 'Vehicle impoundment', 'Nothing for first offense'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 4,
        text: 'During the probationary period (Class 5 GDL), how many passengers under 18 can you carry (excluding immediate family)?',
        options: ['No limit', 'One passenger', 'Only one unless accompanied by a supervising driver', 'Two passengers'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 5,
        text: 'The minimum age to obtain a Class 7 learner\'s licence in Alberta is:',
        options: ['14 years', '16 years', '15 years', '18 years'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 6,
        text: 'If you are convicted of impaired driving, you will:',
        options: ['Receive a warning', 'Face licence suspension, fines, and possible jail time', 'Only pay a small fine', 'Attend a driving course'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 7,
        text: 'Demerit points remain on your record for:',
        options: ['1 year', '2 years from the date of conviction', '5 years', 'Permanently'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 8,
        text: 'Racing or stunting on a highway can result in:',
        options: ['A small fine only', 'Vehicle seizure, licence suspension, and heavy fines', 'Demerit points only', 'A warning for first-time offenders'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 9,
        text: 'A Class 7 learner driver is NOT allowed to drive:',
        options: ['Between midnight and 5 a.m. unless accompanied by a fully licensed driver or for work/education', 'In residential areas', 'On highways', 'During winter'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 10,
        text: 'What is the penalty for not stopping for a school bus with flashing red lights?',
        options: ['$100 fine', 'Significant fine and 6 demerit points', 'Warning only', 'Community service'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 11,
        text: 'If you fail to display the "N" sign as a new driver, you may:',
        options: ['Be fined', 'Receive demerit points', 'Have your licence suspended', 'All of the above are possible'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 12,
        text: 'How long is the probationary period for a Class 5-GDL driver?',
        options: ['1 year', '2 years', '18 months', '6 months'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 13,
        text: 'Driving while your licence is suspended can result in:',
        options: ['A warning', 'Vehicle seizure, additional suspension, and fines', 'Demerit points', 'Mandatory driving course'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 14,
        text: 'The legal blood alcohol limit for a fully licensed (non-GDL) driver in Alberta is:',
        options: ['0.05%', '0.08%', '0.10%', '0.00%'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 15,
        text: 'If you receive a traffic ticket, you must:',
        options: ['Ignore it', 'Pay the fine or dispute it within the specified time', 'Wait for a court summons', 'Throw it away'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 16,
        text: 'Speeding in a school zone or playground zone can result in:',
        options: ['Double the regular fine', 'A warning', 'No penalty for first offense', 'Community service'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 17,
        text: 'What must you do if a police officer pulls you over?',
        options: ['Keep driving to find a better spot', 'Stop immediately in a safe location, remain in vehicle, and provide licence and registration', 'Exit the vehicle immediately', 'Call your lawyer first'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 18,
        text: 'Failure to yield to a pedestrian in a crosswalk results in:',
        options: ['A warning', 'Fine and demerit points', 'Vehicle impoundment', 'Nothing if no collision occurs'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 19,
        text: 'Can a Class 7 learner drive on the highway?',
        options: ['No, never', 'Yes, when accompanied by a supervising driver', 'Only during daytime', 'Yes, without restrictions'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 20,
        text: 'What happens if you accumulate too many demerit points?',
        options: ['Nothing happens', 'Your licence may be suspended', 'You receive a warning letter only', 'You must retake the written test'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 21,
        text: 'Alberta\'s Immediate Roadside Sanction (IRS) program allows officers to:',
        options: ['Issue warnings only', 'Immediately suspend licences and seize vehicles for impaired driving', 'Give drivers a second chance', 'Require attendance at a presentation'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 22,
        text: 'Driving with a suspended licence can result in:',
        options: ['A fine only', 'Additional suspension time, fines, and possible jail time', 'A warning', 'Demerit points'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 23,
        text: 'What is required to advance from Class 7 to Class 5-GDL?',
        options: ['Pay a fee only', 'Pass a road test', 'Wait 2 years', 'Complete a driving course'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 24,
        text: 'A conviction for driving without insurance results in:',
        options: ['A small fine', 'Vehicle seizure, licence suspension, and significant fines', 'A warning', 'Demerit points only'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 25,
        text: 'If you change your address, you must notify Alberta Registries within:',
        options: ['7 days', '14 days', '30 days', '60 days'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 26,
        text: 'The vision requirement for a driver\'s licence in Alberta is:',
        options: ['20/20 vision', '20/40 vision or better, corrected or uncorrected', '20/60 vision', 'No requirement'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 27,
        text: 'What must a Class 5-GDL driver display on their vehicle?',
        options: ['Nothing', 'An "N" sign', 'An "L" sign', 'A "P" sign'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 28,
        text: 'Excessive speeding (50 km/h or more over the limit) can result in:',
        options: ['A warning', 'Immediate vehicle seizure and licence suspension', 'Double demerit points', 'A small fine'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 29,
        text: 'To upgrade from Class 5-GDL to a full Class 5 licence, you must:',
        options: ['Pay a fee only', 'Complete the 2-year probationary period with a clean record and pass an advanced road test', 'Wait 1 year', 'Take a written test'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 30,
        text: 'What happens if you refuse a roadside breath test when requested by police?',
        options: ['Nothing', 'It is treated the same as failing the test - licence suspension and penalties', 'You get a warning', 'You can request a lawyer first'],
        img: null,
        answerIndex: 1,
      },
    ]
  },
  {
    id: 10,
    title: 'Mock Test 10',
    description: 'Comprehensive review covering all aspects of Class 7 knowledge',
    questions: [
      {
        id: 1,
        text: 'When approaching a stopped emergency vehicle with flashing lights on a highway, you must:',
        options: ['Maintain speed', 'Slow down and move over if safe to do so', 'Speed up to pass quickly', 'Stop behind the vehicle'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 2,
        text: 'What is the purpose of a traffic circle or roundabout?',
        options: ['To confuse drivers', 'To improve traffic flow and reduce collisions', 'To slow down traffic', 'To provide parking'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 3,
        text: 'When can you use your horn?',
        options: ['To greet friends', 'To express anger', 'To warn others of danger', 'Anytime you want'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 4,
        text: 'A diamond-shaped pavement marking indicates:',
        options: ['Reserved lane (HOV, bus, bicycle)', 'Pedestrian crossing', 'Railroad crossing', 'School zone'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 5,
        text: 'When driving on a multi-lane highway, you should:',
        options: ['Stay in the left lane', 'Use the right lane except when passing', 'Change lanes frequently', 'Drive in the center lane only'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 6,
        text: 'If you are involved in a collision, your first priority should be:',
        options: ['Move your vehicle', 'Take photos', 'Check for injuries and call 911 if needed', 'Exchange insurance information'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 7,
        text: 'What does a blue sign with white symbols typically indicate?',
        options: ['Warning', 'Services or guidance', 'Prohibition', 'Construction'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 8,
        text: 'When merging onto a highway from an entrance ramp, you should:',
        options: ['Stop at the end of the ramp', 'Signal and match the speed of highway traffic', 'Merge slowly', 'Expect others to slow down for you'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 9,
        text: 'A white "X" on a pavement indicates:',
        options: ['No parking', 'Railroad crossing', 'Pedestrian crossing', 'Stop line'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 10,
        text: 'When parking on a roadway at night, you must:',
        options: ['Leave parking lights on', 'Turn off all lights', 'Leave headlights on', 'Use hazard lights'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 11,
        text: 'The most important thing to do before backing up is to:',
        options: ['Sound your horn', 'Check all around including blind spots', 'Roll down windows', 'Turn on hazard lights'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 12,
        text: 'When approaching a horse and rider on the road, you should:',
        options: ['Honk to alert them', 'Pass quickly', 'Slow down and pass carefully, giving them space', 'Maintain speed'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 13,
        text: 'What does a pennant-shaped sign indicate?',
        options: ['School zone', 'No passing zone', 'Railway crossing', 'Construction'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 14,
        text: 'If your vehicle begins to hydroplane, you should:',
        options: ['Brake hard', 'Ease off the accelerator and steer straight', 'Turn sharply', 'Accelerate'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 15,
        text: 'When are you required to use windshield wipers?',
        options: ['Only in heavy rain', 'Whenever you need headlights due to poor visibility', 'Never required', 'Only at night'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 16,
        text: 'A solid line on your side with a broken line on the other side means:',
        options: ['You may pass', 'You may not pass, but oncoming traffic may', 'No passing either direction', 'Pass with caution'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 17,
        text: 'When traveling down a steep hill, you should:',
        options: ['Use a lower gear to help control speed', 'Coast in neutral', 'Brake continuously', 'Accelerate'],
        img: null,
        answerIndex: 0,
      },
      {
        id: 18,
        text: 'The safest way to transport a child under 6 years old is:',
        options: ['In the front seat with a seatbelt', 'In an appropriate child safety seat in the back seat', 'Held by an adult', 'With an adult seatbelt'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 19,
        text: 'A "No Stopping" sign means:',
        options: ['You may stop briefly to load passengers', 'You cannot stop for any reason except emergency', 'You can park for 5 minutes', 'Buses only may stop'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 20,
        text: 'When driving behind a motorcycle, you should:',
        options: ['Follow closely', 'Allow the same following distance as for a car or more', 'Pass immediately', 'Honk frequently'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 21,
        text: 'What should you do if you encounter a funeral procession?',
        options: ['Pass it quickly', 'Yield and do not interrupt the procession', 'Honk respectfully', 'Join the procession'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 22,
        text: 'Orange signs typically indicate:',
        options: ['Warnings', 'Construction or temporary conditions', 'Services', 'Railroad'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 23,
        text: 'When can you cross a solid yellow line to pass?',
        options: ['Anytime', 'Never', 'Only to pass a cyclist or slow-moving vehicle when safe', 'Only on highways'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 24,
        text: 'If you are driving and feel drowsy, the best action is to:',
        options: ['Drink coffee and continue', 'Open windows', 'Stop and rest or change drivers', 'Turn up music'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 25,
        text: 'What is the purpose of rumble strips on the highway?',
        options: ['To slow down traffic', 'To alert drivers who drift off the road', 'To mark parking areas', 'Decoration'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 26,
        text: 'When can you make a U-turn?',
        options: ['Anytime', 'Where it is safe and not prohibited by signs', 'Never', 'Only on highways'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 27,
        text: 'The greatest danger to a motorcyclist is:',
        options: ['Weather', 'Other vehicles not seeing them', 'Speed', 'Road conditions'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 28,
        text: 'A green light means:',
        options: ['You must go immediately', 'Proceed when safe, yielding to vehicles and pedestrians already in the intersection', 'Speed up', 'Turn only'],
        img: null,
        answerIndex: 1,
      },
      {
        id: 29,
        text: 'What should you do when you see an ambulance with lights and sirens behind you?',
        options: ['Speed up', 'Stop immediately', 'Pull to the right and stop when safe', 'Change lanes quickly'],
        img: null,
        answerIndex: 2,
      },
      {
        id: 30,
        text: 'Maintaining your vehicle includes:',
        options: ['Only washing it regularly', 'Regular inspections of tires, brakes, lights, and fluids', 'Checking only when warning lights appear', 'Servicing every 5 years'],
        img: null,
        answerIndex: 1,
      },
    ]
  },
];

export default mockTestData;
